import { BooleanInput } from '@angular/cdk/coercion';
import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UiAccordionContentDirective } from '@df/ui/accordion/content/accordion-content.directive';
import { UiAccordionItemDirective } from '@df/ui/accordion/item/accordion-item.directive';
import { UiAccordionTriggerDirective } from '@df/ui/accordion/trigger/accordion-trigger.directive';
import { UiButtonDirective } from '@df/ui/button/button.directive';
import { UiComponent } from '@df/ui/ui.component';

@Component({
    selector: 'accordion-item',
    templateUrl: './accordion-item.component.html',
    styleUrl: './accordion-item.component.scss',
    hostDirectives: [
        {
            directive: UiAccordionItemDirective,
            inputs: ['uiAccordionItemValue:value', 'uiAccordionItemDisabled:disabled']
        }
    ],
    imports: [UiAccordionContentDirective, UiAccordionTriggerDirective, UiButtonDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionItemComponent extends UiComponent {
    readonly icon = input<boolean, BooleanInput>(true, { transform: booleanAttribute });
}
